import React from 'react';
import { withFormik } from 'formik';
import { isEmpty } from 'ramda';

import styles from './styles.m.scss';

import magic from '../../../../../util/magic';
import { apiAddFile } from '../../../../../api/registration';
import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';
import { routes } from '../../../../../routes';

import Footer from '../../../../../components/Accordion/Footer';
import FileBrowser from '../../../../../components/Forms/FileBrowser';
import FormGroup from '../../../../../components/Forms/FormGroup';
import { getFileWithKey } from '../../../../../util/helpers';

const EmploymentVerification = ({
  errors,
  handleSubmit,
  isSubmitting,
  isValid,
  registration,
  setStep,
  step,
  updateRegistrationMedia,
}) => {
  return (
    <form>
      <h2 className={styles.stepHeader}>
        Submit the completed{' '}
        <a className="text-underline" href={routes.wordPress.employmentVerification} target="_blank">
          Employment Verification Form
        </a>
      </h2>
      <p>
        Incomplete or illegible applications will not be processed. Please submit a separate form for each employer.
      </p>
      <p>
        If you are employed, please complete Section A and have your manager or supervisor complete Section B certifying
        your employment status.
      </p>
      <p>
        If you are a volunteer, please complete Section A and Section B self-certifying employment status. Section C
        should be completed by an individual knowledgeable about your volunteer work.
      </p>
      <p>
        If you are self-employed, please complete Section A and Section B self-certifying employment status. Section C
        should be completed by an individual knowledgeable about your practice.
      </p>
      <FormGroup label="Employment Verification Files">
        <FileBrowser
          error={errors.employmentVerificationFile}
          files={registration.media}
          fileKey={magic.employmentVerification}
          name="employmentVerificationFile"
          addFile={(file) => apiAddFile(registration.id, file)}
          update={updateRegistrationMedia}
        />
      </FormGroup>
      <Footer step={step} setStep={setStep} isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
    </form>
  );
};

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: () => ({}),
  validate: (values, props) => {
    const { registration } = props;
    const errors = {};
    if (!getFileWithKey(registration.media, magic.employmentVerification)) errors.employmentVerification = 'Required';
    return errors;
  },
  isInitialValid: ({ initialValues, validate }) => isEmpty(validate(initialValues)),
  validateOnChange: true,
})(EmploymentVerification);
